import { useParams, useNavigate, Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./ServiceDetailPage.css";

const serviceData = {
  endoscopy:           { titleKey:"endoscopy",           subtitleKey:"endoscopySubtitle",           heroImage:"Endoscopy.png",              descKey:"endoscopyDesc",           detailKeys:["endoscopyD1","endoscopyD2","endoscopyD3","endoscopyD4"] },
  colonoscopy:         { titleKey:"colonoscopy",         subtitleKey:"colonoscopySubtitle",         heroImage:"Colonoscopy.png",            descKey:"colonoscopyDesc",         detailKeys:["colonoscopyD1","colonoscopyD2","colonoscopyD3","colonoscopyD4"] },
  ercp:                { titleKey:"ercp",                subtitleKey:"ercpSubtitle",                heroImage:"ERCP.png",                   descKey:"ercpDesc",                detailKeys:["ercpD1","ercpD2","ercpD3","ercpD4"] },
  biopsy:              { titleKey:"biopsy",              subtitleKey:"biopsySubtitle",              heroImage:"Biopsy.png",                 descKey:"biopsyDesc",              detailKeys:["biopsyD1","biopsyD2","biopsyD3","biopsyD4"] },
  varicealLigation:    { titleKey:"varicealLigation",    subtitleKey:"varicealLigationSubtitle",    heroImage:"variceal-ligation.png",      descKey:"varicealLigationDesc",    detailKeys:["varicealD1","varicealD2","varicealD3","varicealD4"] },
  foreignBodyRemoval:  { titleKey:"foreignBodyRemoval",  subtitleKey:"foreignBodyRemovalSubtitle",  heroImage:"foreign-body-removal.png",   descKey:"foreignBodyRemovalDesc",  detailKeys:["foreignBodyD1","foreignBodyD2","foreignBodyD3","foreignBodyD4"] },
  enteralMetalStenting:{ titleKey:"enteralMetalStenting",subtitleKey:"enteralMetalStentingSubtitle",heroImage:"enteral-metal-stenting.png", descKey:"enteralMetalStentingDesc",detailKeys:["enteralD1","enteralD2","enteralD3","enteralD4"] },
  pegPlacement:        { titleKey:"pegPlacement",        subtitleKey:"pegPlacementSubtitle",        heroImage:"peg-placement.png",          descKey:"pegPlacementDesc",        detailKeys:["pegD1","pegD2","pegD3","pegD4"] },
  polypectomy:         { titleKey:"polypectomy",         subtitleKey:"polypectomySubtitle",         heroImage:"Polypectomy.png",            descKey:"polypectomyDesc",         detailKeys:["polypD1","polypD2","polypD3","polypD4"] },
  hemoclipApplication: { titleKey:"hemoclipApplication", subtitleKey:"hemoclipApplicationSubtitle", heroImage:"hemoclip-application.png",   descKey:"hemoclipApplicationDesc", detailKeys:["hemoclipD1","hemoclipD2","hemoclipD3","hemoclipD4"] },
  estUlcer:            { titleKey:"estUlcer",            subtitleKey:"estUlcerSubtitle",            heroImage:"est-of-ulcer.png",           descKey:"estUlcerDesc",            detailKeys:["estD1","estD2","estD3","estD4"] },
  strictureDilatation: { titleKey:"strictureDilatation", subtitleKey:"strictureDilatationSubtitle", heroImage:"stricture-dilatation.png",   descKey:"strictureDilatationDesc", detailKeys:["strictureD1","strictureD2","strictureD3","strictureD4"] },
};

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ServiceDetailPage = () => {
  const { serviceKey } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const service = serviceData[serviceKey];

  if (!service) {
    return (
      <div className="sdp-not-found">
        <h2>Service not found</h2>
        <button className="sdp-back-btn" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const otherServices = Object.entries(serviceData)
    .filter(([key]) => key !== serviceKey)
    .slice(0, 4);

  return (
    <div className="sdp-page nb-page-offset">
      <Navbar />
      {/* Hero */}
      <section className="sdp-hero" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/${service.heroImage})`}}>
        <div className="sdp-hero-overlay" />
        <div className="sdp-hero-content">
          <button className="sdp-back-btn" onClick={() => navigate(-1)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            {t("backToServices")}
          </button>
          <div className="sdp-eyebrow">{t("ourServicesEyebrow")}</div>
          <h1 className="sdp-hero-title">{t(service.titleKey)}</h1>
          <p className="sdp-hero-subtitle">{t(service.subtitleKey)}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="sdp-main">
        <div className="sdp-main-inner">
          {/* Left: Details */}
          <div className="sdp-content-col">
            <div className="sdp-card">
              <h2 className="sdp-section-title">{t("aboutThisProcedure")}</h2>
              <p className="sdp-desc">{t(service.descKey)}</p>
            </div>

            <div className="sdp-card">
              <h2 className="sdp-section-title">{t("benefits")}</h2>
              <ul className="sdp-list">
                {service.detailKeys.map((key, i) => (
                  <li key={i} className="sdp-list-item">
                    <span className="sdp-check"><CheckIcon /></span>
                    {t(key)}
                  </li>
                ))}
              </ul>
            </div>

          </div>

          {/* Right: Sidebar */}
          <div className="sdp-sidebar">
            <div className="sdp-sidebar-card sdp-book-card">
              <h3>{t("bookThisProcedure")}</h3>
              <p>{t("scheduleConsultDesc")}</p>
              <Link to="/" className="sdp-book-btn">{t("bookNow")}</Link>
              <a href="tel:+919996504991" className="sdp-call-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
                +91 9996504991
              </a>
            </div>

            <div className="sdp-sidebar-card">
              <h3>{t("doctorSidebarTitle")}</h3>
              <div className="sdp-doctor-mini">
                <img src={process.env.PUBLIC_URL + "/ashok.png"} alt="Dr. Ashok Kumar" className="sdp-doctor-img" />
                <div>
                  <div className="sdp-doctor-name">Dr. Ashok Kumar</div>
                  <div className="sdp-doctor-deg">{t("drAshokDeg")}</div>
                  <Link to="/doctor" className="sdp-doctor-link">{t("viewProfile")}</Link>
                </div>
              </div>
            </div>

            <div className="sdp-sidebar-card">
              <h3>{t("otherServicesTitle")}</h3>
              <ul className="sdp-other-list">
                {otherServices.map(([key, svc]) => (
                  <li key={key}>
                    <Link to={"/services/" + key} className="sdp-other-link">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                      {t(svc.titleKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ServiceDetailPage;
